import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { isAccessCode } from "@/features/purchasePoints/errors/purchasePointsError";
import type { PurchasePointsAccessCode, PurchasePointsError } from "@/features/purchasePoints/errors/purchasePointsError";

// The employee switched the feature off in another tab: this refusal says the
// session is out of date as much as it refuses. Left unrefreshed, the
// authorisations tab would still draw the switch on, and the employee would
// switch it off believing he switches it back on.
const OPTED_OUT_CODE = "employee_opted_out";

/**
 * Turns any access refusal into the one state its page renders in place of its
 * usual content. Shared by every reading that can block a whole page: the
 * personal catalogue as much as a single brand's, neither singles out
 * `consumer_not_onboarded` any more, both readings the invalidation.
 */
export const usePurchasePointsBlockingAccess = (
  error: PurchasePointsError | null,
): { code: PurchasePointsAccessCode, detail: string | null } | null => {
  const queryClient = useQueryClient();
  const code = error?.code;

  useEffect(() => {
    if (code === OPTED_OUT_CODE) queryClient.invalidateQueries({ queryKey: ["user"] });
  }, [code, queryClient]);

  if (!error || !isAccessCode(error.code)) return null;
  return { code: error.code, detail: error.detail };
};
